module.exports = __webpack_public_path__ + "img/RGB_formal_Energy_Institute.c4dea404.png";